import BreadcrumbDatos from "./BreadcrumbDatos";
import { Form } from "react-bootstrap";
import { Col, Row, Button, InputGroup, Alert } from "react-bootstrap";
import { useState, useEffect } from "react";
import { getClientes, deleteCliente } from "../../services/ClientesService";
import MaoTable from "../common/MaoTable";
import { useNavigate } from "react-router-dom";

export default function Clientes() {
    /*
    Links ->
        https://react-bootstrap.netlify.app/
        https://react-bootstrap.netlify.app/docs/getting-started/introduction/
        https://react-bootstrap.netlify.app/docs/components/breadcrumb
        https://react-bootstrap.netlify.app/docs/forms/overview
        https://react-bootstrap.netlify.app/docs/forms/layout
        https://react-bootstrap.netlify.app/docs/forms/input-group

        https://www.npmjs.com/package/react-icons
     */
    
    const [clientes, setClientes] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        buscar();
    }, [])

    async function buscar() {
        let nombreParam = document.getElementById("txtNombre").value;
        let inactivosParam = document.getElementById("chkIncluirInactivos").checked;
        let resp = await getClientes(nombreParam, inactivosParam);
        if (resp.error) {
            setError(resp.message);
            setClientes([]);
        } else {
            setError("");
            setClientes(resp.data);
        }
    }

    const navigate = useNavigate();

    function nuevo() {
        navigate("/clientes/nuevo");
    }

    async function editar(id) {
        navigate("/clientes/"+id);
    }

    async function borrar(id) {
        if (window.confirm("¿Esta seguro que quiere borrar el cliente?")) {
            const resp = await deleteCliente(id);
            if (resp.error) {
                alert(resp.message);
            } else {
                alert("Cliente borrado correctamente");
                buscar();
            }
        }
    }

    const columnas = [
        {
            titulo:"Cuit",
            atributo:"cuit"
        },
        {
            titulo:"Nombre / Razón Social",
            atributo:"nombre_razon_social",
            className:"text-truncate max-width-20-em"
        },
        {
            titulo:"Teléfono",
            atributo:"telefono"
        },
        {
            titulo:"Cuidad",
            atributo:"ciudad",
            className:"d-none d-md-table-cell"
        },
        {
            titulo:"Email",
            atributo:"email",
            className:"d-none d-md-table-cell"
        },
        {
            titulo:"Estado",
            atributo:"estado"
        }
    ]

    return <>
        <BreadcrumbDatos active="Clientes - Consulta"/>
        <Form>
            <Row className="align-items-center">
                <Col xs="auto" md="6">
                <InputGroup className="mb-2">
                <Form.Label htmlFor="inlineFormInput" visuallyHidden>
                    Nombre
                </Form.Label>
                <Form.Control
                    id="txtNombre" 
                    placeholder="Nombre a buscar..."
                />
                <Button id="btnBuscar" onClick={buscar}>
                    Buscar
                </Button>
                </InputGroup>
                </Col>
                <Col xs="auto">
                    <Form.Check
                        type="checkbox"
                        id="chkIncluirInactivos"
                        className="mb-2"
                        label="Incluir inactivos"
                        onClick={buscar}
                    />
                </Col>
            </Row>
            {error!==''?
                <Row>
                    <Col xs="auto">
                        <Alert variant="danger" key="danger">{error}</Alert>
                    </Col>
                </Row>:
                <></>
            }
        </Form>
        <MaoTable 
            columnas={columnas} 
            datos={clientes} 
            colId="cliente_id"
            colEstado="estado"
            colNombre="nombre_razon_social"
            borrar={borrar} editar={editar}>
        </MaoTable>
        <Row>
            <Col xs="auto">
                <Button id="btnNuevo" onClick={nuevo}>Nuevo</Button>
            </Col>
        </Row>
    </>
        
}